import { LOCAL, ROOT_FLAG } from "@/store/mutations";

const { PLAY_MUSIC, PAUSE_MUSIC, STOP_MUSIC } = LOCAL;

export default {
	namespaced: true,
	state: {
		playing: false,
		active: null,
	},
	actions: {
		play({ dispatch, commit }, music) {
			dispatch("sound/play", {
				...music,
				loop: true,
				events: {
					play: () => commit(PLAY_MUSIC, music),
					pause: () => commit(PAUSE_MUSIC),
					stop: () => commit(STOP_MUSIC),
				},
			}, ROOT_FLAG);
		},
		pause({ dispatch, state }) {
			if (state.playing) {
				dispatch("sound/pause", { ...state.active }, ROOT_FLAG);
			}
		},
		stop({ dispatch, state }) {
			if (state.active) {
				dispatch("sound/stop", { ...state.active }, ROOT_FLAG);
			}
		},
		fade({ state, dispatch }, fade) {
			if (state.playing) {
				dispatch("sound/fade", {
					id: state.active.id,
					...fade,
				}, ROOT_FLAG);
			}
		},
	},
	mutations: {
		[PLAY_MUSIC](state, music) {
			state.playing = true;
			state.active = music;
		},
		[PAUSE_MUSIC](state) {
			state.playing = false;
		},
		[STOP_MUSIC](state) {
			state.playing = false;
			state.active = null;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/sound/music.store.js